<template>
    <div class="chtBox">
        <div class="staBtTitle">
            <div class="staTitle col"></div>
            <div class="col staEx">
                <ExportButton @onExportData="onExportData" @onExportToPng="onExportToPng"></ExportButton>
            </div>
        </div>

        <!--<DxSelectBox :data-source="stList"
                     display-expr="stName"
                     value-expr="stId"
                     v-model:value="selectedStId" />-->
        <DxVectorMap id="vector-map"
                     :bounds="bounds"
                     ref="chart"
                     title="Stakeholder Countries">
            <DxControlBar ref="controlBar" :enabled="false"/>
            <DxSize :height="633" />
            <DxLayer :data-source="mapsWorld"
                     id="chart"
                     hover-enabled="true"
                     name="areas"
                     :customize="customizeLayer"
                     hovered-border-color="#ececec"
                     border-color="#ececec" />

            <!--<DxLayer :data-source="dataSource"
             :size-groups="sizeGroups"
             :min-size="15"
             :max-size="25"
             :opacity="0.8"
             name="bubbles"
             color="#e20074"
             element-type="bubble"
             data-field="value" />-->
            <DxTooltip :enabled="true"
                       :customize-tooltip="customizeTooltip" />
        </DxVectorMap>
    </div>
</template>

<script>
    import * as mapsData from 'devextreme-dist/js/vectormap-data/world.js';
    //import DxSelectBox from 'devextreme-vue/select-box';
    //import ExportButton from './exportButton.vue';
    import axios from 'axios'
    import { excelParser } from "../../../plugins/excel-parser";
    import {
        DxVectorMap,
        DxLayer,
        DxTooltip,
        DxSize,
        DxControlBar
    } from 'devextreme-vue/vector-map';
    const baseUri = "WebApi.asmx/api/statisticsService";
    export default {
        name: 'CountryStatsMap',
        components: {
            DxLayer,
            DxSize,
            DxVectorMap,
            DxTooltip,
            DxControlBar,
            //DxSelectBox,
            //ExportButton
        },
        data() {
            return {
                stList: [{ stName: "All", stId: 0 }, { stName: "Completed", stId: 10 }, { stName: "Draft", stId: 1 }],
                selectedStId: 0,
                mapsWorld: [],
                bounds: [-180, 85, 180, -60],
                sizeGroups: [0],
                dataSource: [],
                countrySource: []

            };
        },
        computed: {
            dataSourceEx() {
                var result = this.dataSource;
                var mapData = {
                    type: 'FeatureCollection',
                    features: []
                }
                var sum = 0;
                for (var key in result) {
                    sum += result[key].ItemCount;
                }
                if (sum) {
                    result.forEach(e => {
                        if (e.CouLatitude) {
                            this.sizeGroups.push((e.ItemCount / sum) * 100);
                            mapData.features.push({ type: "Feature", geometry: { type: "Point", coordinates: [e.CouLongitude, e.CouLatitude] }, properties: { text: e.CouName, value: e.ItemCount, tooltip: `<b>${e.CouName}</b>\n${e.ItemCount}`, } })
                        }
                    })
                }
                return mapData;
            },
        },
        mounted: function () {
            axios
                .get(baseUri + '/GetEsaCountryStats', { params: { RouId: 0, TtyId: 0, StgId: this.selectedStId } })
                .then(res => {
                    if (res.data.success == true) {
                        this.dataSource = res.data.data;
                        this.mapsWorld = mapsData.world
                    }
                    else {
                        alert(res.data.errorMessage)
                    }
                })
            //this.$store.dispatch("getEsaCountryStats", { rouId: 0, ttyId: 0, stgId: this.selectedStId })
        },
        methods: {
            //customizeTooltip(info) {
            //    if (info.layer.type === 'marker') {
            //        return { text: info.attribute('tooltip') };
            //    }
            //    return null;
            //},
            customizeTooltip(info) {
                
                const shortName = info.attribute('name');
                const name = info.attribute('iso_a2');

                const country = this.dataSource.find(m => { return m.CouShortName == name });
                if (country) {
                    info.applySettings({
                        hoveredColor: '#c00063',
                        selectedColor: '#008f00',
                    });
                    return {
                        text: `${shortName}: ${country.ItemCount}`,

                    };
                }
                return null;
            },
            customizeLayer(elements) {
                elements.forEach((element) => {

                    const country = this.dataSource.find(m => { return m.CouShortName == element.attribute('iso_a2') });
                    if (country) {
                        element.applySettings({
                            color: '#c00063',
                            hoveredColor: '#c00063',
                            selectedColor: '#008f00',
                        });
                    }
                });
            },
            onExportData() {
                
                excelParser().exportDataFromJSON(this.dataSource, "Ideas_perCountries", null);

            },

            onExportToPng() {
                
                this.$refs.chart.instance.exportTo('ideasPerCountry', 'png');
            },
        },
        watch: {
            //selectedStId: function (newVal, oldVal) {
            //    if (newVal != oldVal) {
            //        this.sizeGroups = [0];
            //        this.$store.dispatch("getCountryStats", { rouId: 0, ttyId: 0, stgId: this.selectedStId })
            //    }
            //},
            selectedStId: function (newVal, oldVal) {
                if (newVal != oldVal) {
                    axios
                        .get(baseUri + '/GetEsaCountryStats', { params: { RouId: 0, TtyId: 0, StgId: this.selectedStId } })
                        .then(res => {
                            if (res.data.success == true) {
                                this.dataSource = res.data.data;
                            }
                            else {
                                alert(res.data.errorMessage)
                            }
                        })
                }
            },
            sizeGroups: function () {

            },
            dataSource: function () {
                //var e = this.$refs.chart.instance.getElements()

            }
        }
    }

</script>
<style scoped>
    .staBtTitle {
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        width: 100%;
    }

    .staTitle {
        text-align: left
    }

    .staEx {
        align-items: flex-end;
    }

    div.col {
        display: flex;
        flex-direction: column;
        flex-basis: 100%;
        flex: 1;
    }
</style>